import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &[hidden] {\n        display: none;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
var StyledTabPanel = styled.div(_templateObject());
export var TabPanel = React.forwardRef(function (_a, ref) {
  var children = _a.children,
      component = _a.component,
      value = _a.value,
      index = _a.index,
      unmountInactive = _a.unmountInactive,
      props = __rest(_a, ["children", "component", "value", "index", "unmountInactive"]);

  var isInactive = index == null || value !== index;

  if (isInactive && unmountInactive) {
    return null;
  }

  return React.createElement(StyledTabPanel, Object.assign({
    ref: ref,
    hidden: isInactive
  }, component && {
    as: component
  }, props), children);
});
TabPanel.displayName = 'TabPanel';